import React from 'react';
import { Radio } from 'antd';

const { Button, Group } = Radio;

const DocumentTypes = ({ onChangeTypeList, totalOrders, typesList, stat }) => {
  return (
    <Group onChange={onChangeTypeList} defaultValue="all">
      <Button value="all">Все: {totalOrders}</Button>
      {typesList &&
        typesList.map(item => {
          let count = stat && stat[item.key] ? stat[item.key] : 0;
          return (
            <Button key={item.key} value={item.key} disabled={!count}>
              {item.status}: {count}
            </Button>
          );
        })}
    </Group>
  );
};

export default DocumentTypes;
